import React, { IframeHTMLAttributes } from 'react'
import EmbedResizeHandle from './EmbedResizeHandle'
import EmbedEditButton from './EmbedEditButton'
import useEmbedControls from '../hooks/useEmbedControls'

export interface IFrameProps extends IframeHTMLAttributes<HTMLIFrameElement> {
  blockProps: {
    src: string
    height: number
    entityKey?: string
    openIframeDialog?: (anchor: HTMLElement, entityKey: string) => void
    onResizeHeight?: (entityKey: string, height: number) => void
  }
}

const IFrame: React.FC<IFrameProps> = (props) => {
  const { blockProps } = props
  const controls = useEmbedControls({
    savedHeight: blockProps.height,
    entityKey: blockProps.entityKey,
    editable: !!blockProps.openIframeDialog && !!blockProps.entityKey,
    onResizeHeight: blockProps.onResizeHeight,
    hoverTracking: 'enterLeave'
  })

  return (
    <div
      {...controls.viewProps}
      data-testid="embedded-iframe-view"
      className="relative w-full"
      style={{ height: `${controls.height}px` }}
    >
      <iframe
        className="block w-full h-full"
        // Mid-drag the pointer can cross the iframe, which would swallow the moves the drag follows.
        style={controls.dragging ? { pointerEvents: 'none' } : undefined}
        src={blockProps.src}
        frameBorder="0"
        title="Embedded Content"
      ></iframe>
      {controls.showEditButton && (
        <EmbedEditButton
          label="Edit Iframe"
          title="Edit iframe"
          onClick={(anchor) => blockProps.openIframeDialog!(anchor, blockProps.entityKey!)}
        />
      )}
      {controls.canResize && <EmbedResizeHandle {...controls.resizeHandleProps} />}
    </div>
  )
}

export default IFrame
